/**
 * 템플릿 코드 파싱 유틸리티
 */
import type { TemplateSection } from '@/features/code-analysis/api/types';

/**
 * 템플릿 코드를 immutable/mutable 섹션으로 분리
 */
export const parseTemplate = (
  fullCode: string,
  mutableCode: string
): { immutablePrefix: string; mutable: string; immutableSuffix: string } => {
  const mutableStartIndex = fullCode.indexOf(mutableCode);

  if (mutableStartIndex === -1) {
    return {
      immutablePrefix: fullCode,
      mutable: '',
      immutableSuffix: '',
    };
  }

  const immutablePrefix = fullCode.slice(0, mutableStartIndex);
  const immutableSuffix = fullCode.slice(mutableStartIndex + mutableCode.length);

  return {
    immutablePrefix,
    mutable: mutableCode,
    immutableSuffix,
  };
};

/**
 * 템플릿 섹션 배열 생성
 */
export const buildTemplateSections = (
  immutablePrefix: string,
  mutableCode: string,
  immutableSuffix: string
): TemplateSection[] => {
  const sections: TemplateSection[] = [];

  if (immutablePrefix) {
    sections.push({
      type: 'immutable',
      code: immutablePrefix,
    });
  }

  sections.push({
    type: 'mutable',
    code: mutableCode,
  });

  if (immutableSuffix) {
    sections.push({
      type: 'immutable',
      code: immutableSuffix,
    });
  }

  return sections;
};

/**
 * Monaco 에디터 position을 템플릿 cursor position으로 변환
 * Monaco는 body만 표시하므로 signature 줄 수를 더해야 함
 * signature와 body 사이에 \n이 하나 더 추가되므로 +1
 */
export const convertToCursorPosition = (
  monacoLine: number,
  monacoColumn: number,
  signatureLineCount: number,
  hasPrefix: boolean
): { section_index: number; line: number; column: number } => {
  const zeroBasedLine = monacoLine - 1;
  const zeroBasedColumn = monacoColumn - 1;

  const mutableSectionLine = zeroBasedLine + signatureLineCount + 1;

  return {
    section_index: hasPrefix ? 1 : 0,
    line: Math.max(1, mutableSectionLine + 1),
    column: zeroBasedColumn,
  };
};
